import { api } from './client';

export interface ConnectedAccount {
  id: string;
  pinterestUserId: string;
  username: string;
  displayName: string | null;
  expiresAt: string;
}

export interface DailyPoint {
  date: string;
  impressions: number;
  saves: number;
  pinClicks: number;
  outboundClicks: number;
}

export interface AnalyticsOverview {
  profile: {
    username: string;
    displayName: string | null;
    profileImage: string | null;
    followerCount: number | null;
    pinCount: number | null;
    boardCount: number | null;
    monthlyViews: number | null;
  };
  range: { start: string; end: string };
  summary: { impressions: number; saves: number; pinClicks: number; outboundClicks: number };
  daily: DailyPoint[];
  source: string;
}

export function listAccounts(token: string | null): Promise<ConnectedAccount[]> {
  return api.get<ConnectedAccount[]>('/analytics/accounts', token);
}

export function getOverview(
  accountId: string,
  range: { start?: string; end?: string },
  token: string | null,
): Promise<AnalyticsOverview> {
  const params = new URLSearchParams();
  if (range.start) params.set('start', range.start);
  if (range.end) params.set('end', range.end);
  const qs = params.toString();
  return api.get<AnalyticsOverview>(
    `/analytics/accounts/${accountId}/overview${qs ? `?${qs}` : ''}`,
    token,
  );
}

/** Returns the Pinterest OAuth authorize URL to redirect the browser to. */
export function getPinterestConnectUrl(token: string | null): Promise<{ url: string }> {
  return api.get<{ url: string }>('/auth/pinterest/start', token);
}
